import request from '@/utils/request'

//人才列表分页查询
export function getconditionPersonList(data) {
  return request({
    url: '/person/getconditionPersonList',
    method: 'post',
    data
  })
}

//单个查询
export function getParticularsPersonByid(data) {
  return request({
    url: '/person/getParticularsPersonByid',
    method: 'get',
    params: data
  })
}

//删除
export function deletePersonBypercode(data) {
  return request({
    url: '/person/deletePersonBypercode',
    method: 'get',
    params: data
  })
}

//新增
export function insertPerson(data) {
  return request({
    url: '/person/insertPerson',
    method: 'post',
    data
  })
}

//修改
export function updatePerson(data) {
  return request({
    url: '/person/updatePerson',
    method: 'put',
    data
  })
}

//es查询
export function getHomePage(data) {
  return request({
    url: '/person/getHomePage',
    method: 'post',
    data
  })
}

//查询目标企业
export function listPerson(data) {
  return request({
    url: '/projectCenter/listPerson',
    method: 'get',
    params: data
  })
}

//添加候选人
export function saveIntermediateList(data) {
  return request({
    url: '/projectCenter/saveIntermediateList',
    method: 'post',
    data
  })
}
